export default class DomComponent {
    el;
    static refs = [];

    static defaultOpts = {
        cache: false
    };

    constructor(el, opts = {}) {

        if(!el) {
            return false;
        }

        opts = Object.assign({}, DomComponent.defaultOpts, opts)

        this.el = el;
        this.el.classList.add('js');

        if(opts.cache) {
            this.ref = Math.random();
            this.el.dataset.ref = this.ref;
            DomComponent.refs[this.ref] = this;
        }
    }

    loaded() {
        this.el.classList.add('js-loaded');
    }

    static getComponentByRef(ref) {
        return DomComponent.refs[ref];
    }

    static getEntryElements() {
        return document.querySelectorAll(this.selector);
    }

    static fromTemplate(data) {
        const html = this.template({data: data});
        const div = document.createElement('div');
        div.innerHTML = html;

        return new this(div.firstElementChild);
    }

    static fromErrorTemplate(error) {
        const html = this.errorTemplate({error: error});
        const div = document.createElement('div');
        div.innerHTML = html;

        return new this(div.firstElementChild, error=true);
    }
}